/**
 * Pre-qualification terms, conditions, and eSign consent (Kathan).
 * Legal text should be reviewed by counsel before production use.
 */
export default function PrequalTermsContent() {
  return (
    <div className="prequal-terms-body">
      <ul className="prequal-terms-checklist" aria-label="Important reminders">
        <li>Please carefully review and retain a copy for your reference.</li>
        <li>
          Reminder: A pre-qualification request only requires soft credit inquiries and has no impact on
          your credit score.
        </li>
      </ul>

      <h3 className="prequal-terms-h3">1. Pre-Qualification Request Terms and Conditions</h3>
      <p>
        You are providing written instruction under the Fair Credit Reporting Act for Kathan and for any
        lenders or other financing parties Kathan may work with to obtain and use information from your
        personal credit profile solely to evaluate your eligibility to pre-qualify for financing to purchase
        a Kathan vehicle.
      </p>
      <p>
        Pre-qualification terms are estimated and valid on a 2021 or newer used Kathan vehicle based on
        the following mileage parameters:
      </p>
      <div className="prequal-terms-table-wrap">
        <table className="prequal-terms-table">
          <caption className="prequal-terms-table-caption">Mileage parameters by amount requested</caption>
          <thead>
            <tr>
              <th scope="col">Amount requested</th>
              <th scope="col">Max vehicle mileage</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>More than $40,000</td>
              <td>25,000 miles or less</td>
            </tr>
            <tr>
              <td>$15,000 – $40,000</td>
              <td>40,000 miles or less</td>
            </tr>
            <tr>
              <td>Less than $15,000</td>
              <td>80,000 miles or less</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Vehicle must not be used for commercial purposes or export (e.g., Uber, Lyft, GrubHub, Instacart,
        delivery, transport, or hauling).
      </p>
      <p>
        For specific credit terms on a vehicle you select, a formal credit application must be submitted,
        which will appear on your credit report and may impact your credit score.
      </p>
      <p>
        Any changes to your request, credit report, or vehicle selection outside the parameters could result
        in less favorable terms or a decline.
      </p>

      <h3 className="prequal-terms-h3">2. Pre-Qualification Conditions &amp; Restrictions</h3>
      <p>Invalid for applicants under the age of 18 (or 19 in Alabama).</p>
      <p>Subject to satisfaction of lender or financing conditions and documentation requirements.</p>
      <p>
        You consent that Kathan and any lenders or financing parties involved in your request may contact
        you by calls, emails, texts, or prerecorded/artificial voice messages for any purpose related to
        your request.
      </p>
      <p>
        Kathan and those parties may monitor and record telephone calls regarding your request or
        application.
      </p>

      <h3 className="prequal-terms-h3">3. State-Specific Notices &amp; Agreements</h3>
      <p>California: A married applicant may apply for an individual account.</p>
      <p>
        Wisconsin: No provision of a marital property agreement or court decree adversely affects the
        interest of the creditor unless the creditor is furnished a copy prior to the time credit is
        granted.
      </p>
      <p>
        Ohio: Ohio laws against discrimination require that all creditors make credit equally available to
        all creditworthy customers. The Ohio Civil Rights Commission administers compliance.
      </p>
      <p>
        New York: A consumer credit report may be ordered in connection with this application. Upon
        request, you will be informed whether a report was ordered and the name of the reporting agency that
        furnished it.
      </p>
      <p>
        Rhode Island &amp; Vermont: A consumer credit report may be ordered for purposes of review,
        collection, or other legitimate purposes associated with the account.
      </p>
      <p>
        Maine: The buyer has the freedom to choose the agent or insurer for any required insurance under a
        credit sale agreement.
      </p>

      <h3 className="prequal-terms-h3">4. Kathan eSign Consent and Agreement</h3>
      <p>
        &quot;We,&quot; &quot;us,&quot; and &quot;our&quot; refer to Kathan and any of its affiliates,
        agents, service providers, assignees, and any lenders or financing parties Kathan may work with.
      </p>
      <p>
        Electronic communications: You consent to receive all communications, agreements, documents,
        notices, statements, and disclosures electronically — including policy agreements, credit
        disclosures, adverse action notices, and all application-related information.
      </p>
      <p>
        Enforceability: Any communication you accept electronically will be enforceable without a paper
        signature.
      </p>
      <p>
        Paper copies: You may request a paper copy at any time by contacting us at the phone number on our
        website. We currently do not charge a fee for paper copies.
      </p>
      <p>
        Withdrawal of consent: You may withdraw this consent by emailing the privacy contact at Kathan.com
        or calling our customer number. Withdrawal takes effect after a reasonable processing period.
      </p>
      <p>
        Contact information: You must keep your email address current with us. If an incorrect email is on
        file, electronic communications sent to that address are considered delivered.
      </p>
      <p>
        Hardware &amp; software requirements — To receive electronic communications you will need:
      </p>
      <ul>
        <li>A computer, mobile device, tablet, or similar device with an internet connection</li>
        <li>A current web browser supporting HTTPS</li>
        <li>Software capable of opening PDF files (e.g., Adobe Acrobat)</li>
        <li>A valid email address</li>
        <li>A printer or sufficient storage to retain copies of electronic communications</li>
      </ul>
    </div>
  );
}
